import { apiRequest, clearAccessToken, getAccessToken } from "./client";

/**
 * NestJS auth contract (Part 72 §72.1): POST /api/auth/{signup,login} return
 * { token, expiresAt, user }. Signup body: { companyName, name, email, password }.
 * Logout is stateless JWT — the frontend clears the local token (Phase 4).
 */
export const authApi = {
  login: (payload) => apiRequest("/api/auth/login", { method: "POST", body: JSON.stringify(payload) }),
  signup: (payload) => apiRequest("/api/auth/signup", { method: "POST", body: JSON.stringify(payload) }),
  me: () => apiRequest("/api/auth/me"),
  /** Clears the local session; best-effort server logout. */
  async logout() {
    try {
      if (getAccessToken()) {
        await apiRequest("/api/auth/logout", { method: "POST" });
      }
    } catch {
      // Token is cleared locally regardless of the server call.
    } finally {
      clearAccessToken();
    }
  },
};
